import { connect } from "react-redux"
import FileUploadAttachment from "./fileAttachment"
import { uploadAttachment } from "../../../redux/actions/fileAttachment/fileAttachment.actions"

const mapStateToProps = (state)=>{
    return {
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        upload : (payload)=>{
            return dispatch(uploadAttachment(payload))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadAttachment);